const GEO_ENDPOINT = 'https://get.geojs.io/v1/ip/country.json';
// Countries with a dedicated translation; everyone else gets English.
const COUNTRY_LANGUAGES = {
  RO: 'ro',
  FR: 'fr',
  RU: 'ru',
};
const REQUEST_TIMEOUT_MS = 3000;

// Detects the visitor's country from their IP and maps it to a supported
// language. Returns null (instead of throwing) on any failure — network
// error, timeout, or a blocked request — so callers can fall back silently.
export const detectLanguageByCountry = async () => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

  try {
    const response = await fetch(GEO_ENDPOINT, { signal: controller.signal });
    if (!response.ok) return null;

    const data = await response.json();
    return COUNTRY_LANGUAGES[data?.country] || 'en';
  } catch (error) {
    return null;
  } finally {
    clearTimeout(timeoutId);
  }
};
